import {Component, signal, inject, ChangeDetectionStrategy} from "@angular/core"
import {FormsModule} from "@angular/forms"
import {MatButtonModule} from "@angular/material/button"
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from "@angular/material/dialog"
import {MatInputModule} from "@angular/material/input"
import {MatSelectModule} from "@angular/material/select"
import {ImageColorSpace} from "@generated"
import {MeasurementType, MeasurementTypes} from "@common/models/settings/settings"
import {Labels} from "@labels"
import {AddTextureDialogResult} from "@platform/models/dialogs/add-texture-dialog-result"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-add-texture-dialog",
    templateUrl: "./add-texture-dialog.component.html",
    styleUrls: ["./add-texture-dialog.component.scss"],
    imports: [MatDialogModule, MatInputModule, FormsModule, MatSelectModule, MatButtonModule],
})
export class AddTextureDialogComponent {
    readonly $imperial = signal(false)
    readonly $showColorSpaceSetting = signal(true)
    readonly $result = signal<AddTextureDialogResult>({
        width: 0,
        height: 0,
        colorSpace: ImageColorSpace.Unknown,
    })
    readonly dialogRef = inject(MatDialogRef<AddTextureDialogComponent>)
    readonly data = inject<{width: number; height: number; displacement: number; measurementType: MeasurementType; showColorSpaceSetting?: boolean}>(
        MAT_DIALOG_DATA,
    )

    constructor() {
        if (this.data) {
            this.$result.set({
                width: this.data.width,
                height: this.data.height,
                displacement: this.data.displacement,
                colorSpace: typeof this.data.showColorSpaceSetting !== "undefined" ? ImageColorSpace.Srgb : ImageColorSpace.Unknown,
            })
            this.$imperial.set(this.data.measurementType === MeasurementTypes.Imperial)
            if (typeof this.data.showColorSpaceSetting !== "undefined") {
                this.$showColorSpaceSetting.set(this.data.showColorSpaceSetting)
            }
        }
    }

    cancelAction(): void {
        this.dialogRef.close(false)
    }

    confirmAction(): void {
        if (this.$result() && this.$imperial()) {
            this.$result.update((current) => ({...current, width: MeasurementTypes.Imperial.convertToMetric(current.width)}))
            this.$result.update((current) => ({...current, height: MeasurementTypes.Imperial.convertToMetric(current.height)}))
            if (this.$result().displacement)
                this.$result.update((current) => ({...current, displacement: MeasurementTypes.Imperial.convertToMetric(current.displacement!)}))
        }
        this.dialogRef.close(this.$result())
    }

    protected readonly ImageColorSpace = ImageColorSpace
    protected readonly Labels = Labels
}
